import moment from 'moment';

import {
  HOUR_MINUTE_DAY_TIME,
  MILITARY_TIME
} from 'bento-ordering/base/constants/timeFormat';

/**
 * input HH:mm
 * output h:mma
 */
export const getTime = time => {
  return moment(time, MILITARY_TIME).format(HOUR_MINUTE_DAY_TIME);
};
